module.exports = __webpack_public_path__ + "static/media/06_crisalide.09a473ab.jpg";